export default __webpack_public_path__ + "static/media/warning--trail-crossing--g2.8a7ddab9.png";